<template>
  <div></div>
</template>

<script>
import Vue from 'vue';

export default Vue.extend({

});
</script>

<style lang="scss" scoped>

</style>
